import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const RejectRegistrationDialog = ({
  open,
  request,
  reason = "",
  reasonError = "",
  submitting = false,
  onClose,
  onReasonChange,
  onSubmit,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey) && !submitting) {
      e.preventDefault();
      onSubmit?.();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700 }}>Reject registration request</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {request?.name
            ? `Rejecting request for ${request.name}${request.employeeId ? ` (${request.employeeId})` : ""}.`
            : "Provide a reason for rejection."}
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          label="Reason"
          placeholder="Enter reason..."
          value={reason}
          onChange={(e) => onReasonChange?.(e.target.value)}
          error={!!reasonError}
          helperText={reasonError}
          disabled={submitting}
          onKeyDown={handleKeyDown}
          sx={{
            "& textarea": {
              maxHeight: 120,
              overflowY: "auto !important",
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={submitting}>
          Cancel
        </Button>
        <LoadingButton color="error" variant="contained" onClick={onSubmit} loading={submitting}>
          Reject
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default RejectRegistrationDialog;
